<template>
  <div class="content-tab sysdhcp">
    <loading :mask=true :size="'big'" :isWhite=true v-if="isShowLoading"/>
    <div class="content-body">
      <scrollbar ref="scrollbar" class="scrollbar-body">
        <div class="formDeviceMode" v-show="isOobPortExist()">
          <div class="formRow deviceMode">
            <div class="formselect">
                <div class="title">{{$t('systemDhcp.managementMode')}}</div>
                <q-select class="q-select" :options-array="managementModeOptions" :value="getItemEnableMode()" @change="onManagementModeTypeChange"></q-select>
            </div>
            <div class="formlabel">
                <div class="info">{{$t('systemDhcp.managementModeInfo')}}</div>
            </div>
          </div>
        </div>
        <div class="formDevice vlan" :class="{disabled: !isItemEnableModeChecked(getConfigObject('vlan1'))}">
          <div class="formRow deviceMachine" v-show="isOobPortExist()">
            <machine ref="machine"></machine>
          </div>
          <div class="formRow deviceName" v-show="isOobPortExist()">
            <div class="title">{{$t('systemDhcp.vlanPort')}}</div>
          </div>
          <div class="formRow dhcp">
            <div class="formlabel">
              <radio :label="$t('systemDhcp.radiodhcp')" :checked="isItemEnableDhcpChecked(getConfigObject('vlan1'))" @click.native="onSelection(getConfigObject('vlan1'), 'DHCP')" :id="'radio-dhcp'"></radio>
              <!-- <div class="refresh icon-refresh" @click="onReload"/> -->
            </div>
            <div class="forminput">
              <div class="table-row">
                <div class="title">{{$t('systemDhcp.ip')}}</div>
                <span>{{getConfigObject('vlan1') && getConfigObject('vlan1').status.ipv4Address}}</span>
              </div>
              <div class="table-row">
                <div class="title">{{$t('systemDhcp.subnet')}}</div>
                <span>{{getConfigObject('vlan1') && getConfigObject('vlan1').status.subnetMask}}</span>
              </div>
              <div class="table-row">
                <div class="title">{{$t('systemDhcp.getway')}}</div>
                <span>{{getConfigObject('vlan1') && getConfigObject('vlan1').status.nextHop}}</span>
              </div>
              <div class="table-row">
                <div class="title">{{$t('systemDhcp.dns')}}</div>
                <span>{{getConfigObject('vlan1') && getConfigObject('vlan1').status.dns}}</span>
              </div>
            </div>
          </div>
          <div class="formRow static">
            <div class="formlabel">
              <radio :label="$t('systemDhcp.radioIp')" :checked="!isItemEnableDhcpChecked(getConfigObject('vlan1'))" @click.native="onSelection(getConfigObject('vlan1'), 'Static')" :id="'radio-static'"></radio>
            </div>
            <div class="forminput">
              <div class="table-row" >
                <div class="title">{{$t('systemDhcp.ip')}}</div>
                <div class="item">
                  <input type="text" ref="ip" name="ipSystem" v-model="getConfigObject('vlan1').config.ipv4Address" class="form-control" @keyup="onBlur(getConfigObject('vlan1'))" @blur="onBlur(getConfigObject('vlan1'))" :disabled="isItemEnableDhcpChecked(getConfigObject('vlan1')) || !isItemEnableModeChecked(getConfigObject('vlan1'))" v-validate.immediate="'required|ip'" :class="{'error': ((errors.has('ipSystem') && !isItemEnableDhcpChecked(getConfigObject('vlan1')))) || getConfigObject('vlan1').check.isIpInvalid}">
                  <div v-show="(errors.has('ipSystem') && !isItemEnableDhcpChecked(getConfigObject('vlan1'))) || getConfigObject('vlan1').check.isIpInvalid || getConfigObject('vlan1').check.isSubmaskInvalid" class="errorMessage">{{ getErrorMsg(getConfigObject('vlan1'), errors.first('ipSystem'), 'ip') }}</div>
                </div>
              </div>
              <div class="table-row">
                <div class="title">{{$t('systemDhcp.subnet')}}</div>
                <div class="item">
                  <q-select class="q-select"  :options-array="subnetList" :class="{'disabled': isItemEnableDhcpChecked(getConfigObject('vlan1')) || !isItemEnableModeChecked(getConfigObject('vlan1'))}" :value="getConfigObject('vlan1').config.subnetMask" @change="onMenuChange(getConfigObject('vlan1'), $event)"></q-select>
                  <div v-show="errors.has('subnetSystem') && !isItemEnableDhcpChecked(getConfigObject('vlan1'))" class="errorMessage">{{ getErrorMsg(getConfigObject('vlan1'), errors.first('subnetSystem'), 'subnet') }}</div>
                </div>
              </div>
              <div class="table-row">
                <div class="title">{{$t('systemDhcp.getway')}}</div>
                <div class="item">
                  <input type="text" name="gatewaySystem" v-model="getConfigObject('vlan1').config.nextHop" class="form-control" @keyup="onBlur(getConfigObject('vlan1'))" :disabled="isItemEnableDhcpChecked(getConfigObject('vlan1')) || !isItemEnableModeChecked(getConfigObject('vlan1'))" v-validate="'gatewayIp|notSameIpGatewayVlan'" :class="{'error': ((errors.has('gatewaySystem') && !isItemEnableDhcpChecked(getConfigObject('vlan1')))) || getConfigObject('vlan1').check.isGetwayInvalid}">
                  <div v-show="(errors.has('gatewaySystem') && !isItemEnableDhcpChecked(getConfigObject('vlan1'))) || getConfigObject('vlan1').check.isGetwayInvalid" class="errorMessage">{{ getErrorMsg(getConfigObject('vlan1'), errors.first('gatewaySystem'), 'gateway') }}</div>
                </div>
              </div>
              <div class="table-row">
                <div class="title">{{$t('systemDhcp.dns')}}</div>
                <div class="item">
                  <input type="text" name="dnsSystem" v-model="getConfigObject('vlan1').config.dns" class="form-control" @keyup="onBlur(getConfigObject('vlan1'))" :disabled="isItemEnableDhcpChecked(getConfigObject('vlan1')) || !isItemEnableModeChecked(getConfigObject('vlan1'))" v-validate="'ip'" :class="{'error': (errors.has('dnsSystem') && !isItemEnableDhcpChecked(getConfigObject('vlan1')))}">
                  <div v-show="errors.has('dnsSystem') && !isItemEnableDhcpChecked(getConfigObject('vlan1'))" class="errorMessage">{{ getErrorMsg(getConfigObject('vlan1'), errors.first('dnsSystem'), 'dns') }}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="line" v-show="isOobPortExist()"></div>
        <div class="formDevice oob" :class="{disabled: !isItemEnableModeChecked(getConfigObject('oob'))}" v-show="isOobPortExist()">
          <div class="formRow deviceMachine">
            <machine :back="true" ref="machine"></machine>
          </div>
          <div class="formRow deviceName">
            <div class="title">{{$t('systemDhcp.oobPort')}}</div>
          </div>
          <div class="formRow dhcp">
            <div class="formlabel">
              <radio :label="$t('systemDhcp.radiodhcp')" :checked="isItemEnableDhcpChecked(getConfigObject('oob'))" @click.native="onSelection(getConfigObject('oob'), 'DHCP')" :id="'radio-dhcp'"></radio>
              <!-- <div class="refresh icon-refresh" @click="onReload"/> -->
            </div>
            <div class="forminput">
              <div class="table-row">
                <div class="title">{{$t('systemDhcp.ip')}}</div>
                <span>{{getConfigObject('oob') && getConfigObject('oob').status.ipv4Address}}</span>
              </div>
              <div class="table-row">
                <div class="title">{{$t('systemDhcp.subnet')}}</div>
                <span>{{getConfigObject('oob') && getConfigObject('oob').status.subnetMask}}</span>
              </div>
              <div class="table-row">
                <div class="title">{{$t('systemDhcp.getway')}}</div>
                <span>{{getConfigObject('oob') && getConfigObject('oob').status.nextHop}}</span>
              </div>
              <div class="table-row">
                <div class="title">{{$t('systemDhcp.dns')}}</div>
                <span>{{getConfigObject('oob') && getConfigObject('oob').status.dns}}</span>
              </div>
            </div>
          </div>
          <div class="formRow static">
            <div class="formlabel">
              <radio :label="$t('systemDhcp.radioIp')" :checked="!isItemEnableDhcpChecked(getConfigObject('oob'))" @click.native="onSelection(getConfigObject('oob'), 'Static')" :id="'radio-static'"></radio>
            </div>
            <div class="forminput">
              <div class="table-row" >
                <div class="title">{{$t('systemDhcp.ip')}}</div>
                <div class="item">
                  <input type="text" ref="ip" name="ipOob" v-model="getConfigObject('oob').config.ipv4Address" class="form-control" @keyup="onBlur(getConfigObject('oob'))" @blur="onBlur(getConfigObject('oob'))" :disabled="isItemEnableDhcpChecked(getConfigObject('oob')) || !isItemEnableModeChecked(getConfigObject('oob'))" v-validate.immediate="'required|ip'" :class="{'error': ((errors.has('ipOob') && !isItemEnableDhcpChecked(getConfigObject('oob')))) || getConfigObject('oob').check.isIpInvalid}">
                  <div v-show="(errors.has('ipOob') && !isItemEnableDhcpChecked(getConfigObject('oob'))) || getConfigObject('oob').check.isIpInvalid || getConfigObject('oob').check.isSubmaskInvalid" class="errorMessage">{{ getErrorMsg(getConfigObject('oob'), errors.first('ipOob'), 'ip') }}</div>
                </div>
              </div>
              <div class="table-row">
                <div class="title">{{$t('systemDhcp.subnet')}}</div>
                <div class="item">
                  <q-select class="q-select"  :options-array="subnetList" :class="{'disabled': isItemEnableDhcpChecked(getConfigObject('oob')) || !isItemEnableModeChecked(getConfigObject('oob'))}" :value="getConfigObject('oob').config.subnetMask" @change="onMenuChange(getConfigObject('oob'), $event)"></q-select>
                  <div v-show="errors.has('subnetOob') && !isItemEnableDhcpChecked(getConfigObject('oob'))" class="errorMessage">{{ getErrorMsg(getConfigObject('oob'), errors.first('subnetOob'), 'subnet') }}</div>
                </div>
              </div>
              <div class="table-row">
                <div class="title">{{$t('systemDhcp.getway')}}</div>
                <div class="item">
                  <input type="text" name="gatewayOob" v-model="getConfigObject('oob').config.nextHop" class="form-control" @keyup="onBlur(getConfigObject('oob'))" :disabled="isItemEnableDhcpChecked(getConfigObject('oob')) || !isItemEnableModeChecked(getConfigObject('oob'))" v-validate="'gatewayIp|notSameIpGatewayOob'" :class="{'error': ((errors.has('gatewayOob') && !isItemEnableDhcpChecked(getConfigObject('oob')))) || getConfigObject('oob').check.isGetwayInvalid}">
                  <div v-show="(errors.has('gatewayOob') && !isItemEnableDhcpChecked(getConfigObject('oob'))) || getConfigObject('oob').check.isGetwayInvalid" class="errorMessage">{{ getErrorMsg(getConfigObject('oob'), errors.first('gatewayOob'), 'gateway') }}</div>
                </div>
              </div>
              <div class="table-row">
                <div class="title">{{$t('systemDhcp.dns')}}</div>
                <div class="item">
                  <input type="text" name="dnsOob" v-model="getConfigObject('oob').config.dns" class="form-control" @keyup="onBlur(getConfigObject('oob'))" :disabled="isItemEnableDhcpChecked(getConfigObject('oob')) || !isItemEnableModeChecked(getConfigObject('oob'))" v-validate="'ip'" :class="{'error': (errors.has('dnsOob') && !isItemEnableDhcpChecked(getConfigObject('oob')))}">
                  <div v-show="errors.has('dnsOob') && !isItemEnableDhcpChecked(getConfigObject('oob'))" class="errorMessage">{{ getErrorMsg(getConfigObject('oob'), errors.first('dnsOob'), 'dns') }}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </scrollbar>
      <div class="content-body-footer">
        <button class="q-button blue-btn-full right" :title="$t('save')" @click="onSaveClick()" :disabled="!isButtonEnable()">{{$t('save')}}</button>
      </div>
    </div>
    <modal class="popup_dialog alert" name="modal-alert" :class="ifTop"
       transition="nice-modal-fade"
       :width="450"
       :min-width="450"
       height="auto"
       :delay="100"
       :draggable="'.modal-header'"
       :clickToClose="false"
       :adaptive="true"
       classes='q-v--modal'>
      <div class="modal-content">
        <div class="modal-header">
          <div class="dialog-icon icon-warning"></div>
          <div class="dialog-header">{{modalTitle}}</div>
          <div class="icon-btn_close modal-close" @click="onClose"></div>
        </div>
        <!-- <div class="icon-btn_close modal-close" @click="onClose()"></div> -->
        <div class="modal-body">
          <div class="modal-container">
            <div class="message">
              {{modalContent}}
            </div>
            <div class="message" v-if="isOriginalMode">
              <a href="https://www.qnap.com/en/utilities/essentials" target="_blank">{{$t('systemDhcp.qfinderTitle')}}</a>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <div class="footer-left">
          </div>
          <div class="footer-right">
            <button class="q-button blue-btn-full" @click="goSave" :title="$t('save')">{{$t('yes')}}</button>
            <button class="q-button" @click="onClose" :title="$t('cancel')">{{$t('cancel')}}</button>
          </div>
        </div>
      </div>
    </modal>
  </div>
</template>

<script>
import Radio from './module/Radio'
import qSelect from './module/Select.vue'
import config from '../config'
import machine from './module/Machine'
import {
  mapState, mapMutations, mapActions, mapGetters
} from 'vuex'
export default {
  name: 'SystemDhcp',
  components: {
    Radio,
    qSelect,
    machine,
    config
  },
  data () {
    return {
      modalname: 'modal-alert',
      ipConfigObjList: [],
      isShowLoading: false,
      subnetList: config.subnetList,
      managementModeOptions: [
        {label: 'systemDhcp.optionInBandMode', value: 'vlan1'},
        {label: 'systemDhcp.optionOutBandMode', value: 'oob'}
      ],
      isOriginalMode: true
    }
  },
  created () {
    this.initValidator()
    this.initConfig()
    this.getData()
  },
  beforeRouteLeave (to, from, next) {
    if (this.isDataChanged) {
      next(false)
    } else {
      next()
    }
  },
  watch: {
    currentUser: {
      handler (value) {
        if (value && value.auth !== undefined) {
          // this.getData()
        }
      },
      immediate: true,
      deep: true
    }
  },
  methods: {
    initConfig: function () {
      let defaultConfigObj = {
        name: 'vlan1',
        type: 'vlan',
        index: 0,
        originalConfig: {},
        config: {
          idx: '1',
          enableDhcpClient: false,
          ipv4Address: '169.254.100.101',
          prefixSize: 0,
          subnetMask: '255.255.0.0',
          nextHop: '',
          dns: '',
          dnsIndex: '1'
        },
        status: {
          enableDhcpClient: false,
          ipv4Address: '',
          prefixSize: 0,
          subnetMask: '',
          nextHop: '',
          dns: ''
        },
        radioType: {
          originalType: '',
          selType: 'DHCP',
          originalModeEnableType: false,
          selModeEnableType: false
        },
        check: {
          isIpInvalid: false,
          isGetwayInvalid: false,
          isSubmaskInvalid: false,
          isGatewayEqualIp: false,
          isConfigModify: false,
          isModeModify: false,
          isShowLoading: false
        }
      }
      this.ipConfigObjList = []
      let configObj = JSON.parse(JSON.stringify(defaultConfigObj))
      configObj.index = this.ipConfigObjList.length
      this.ipConfigObjList.push(configObj)
      if (this.isOobPortExist()) {
        let oobObj = JSON.parse(JSON.stringify(defaultConfigObj))
        oobObj.index = this.ipConfigObjList.length
        oobObj.name = 'oob'
        oobObj.type = 'oob'
        this.ipConfigObjList.push(oobObj)
      }
    },
    initValidator: function () {
      let me = this
      this.$validator.extend('ip', {
        getMessage (field, val) {
          return me.$t('errorMessage.gwAndDnsFormat')
        },
        validate (value, field) {
          var temp = /^([1-9]|[1-9][0-9]|1[0-9][0-9]|2[0-2][0-3])\.([01]?[0-9]?[0-9]|2[0-4][0-9]|25[0-5])\.([01]?[0-9]?[0-9]|2[0-4][0-9]|25[0-5])\.([01]?[0-9]?[0-9]|2[0-4][0-9]|25[0-5])$/
          if (!temp.test(value)) {
            return false
          }
          return true
        }
      })
      this.$validator.extend('subnet', {
        getMessage (field, val) {
          return me.$t('errorMessage.subnetFormat')
        },
        validate (value, field) {
          var temp = /^(([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])\.){3}([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])$/
          if (!temp.test(value)) {
            return false
          }
          return true
        }
      })
      this.$validator.extend('gatewayIp', {
        getMessage (field, val) {
          return me.$t('errorMessage.ipInvalid')
        },
        validate (value, field) {
          var temp = /^([1-9]|[1-9][0-9]|1[0-9][0-9]|2[0-2][0-3])\.([01]?[0-9]?[0-9]|2[0-4][0-9]|25[0-5])\.([01]?[0-9]?[0-9]|2[0-4][0-9]|25[0-5])\.([01]?[0-9]?[0-9]|2[0-4][0-9]|25[0-5])$/
          if (!temp.test(value)) {
            return false
          }
          return true
        }
      })
      this.$validator.extend('notSameIpGatewayVlan', {
        getMessage (field, val) {
          return me.$t('errorMessage.gatewayInvalid')
        },
        validate (value, field) {
          me.getConfigObject('vlan1').check.isGatewayEqualIp = false
          if (value === me.getConfigObject('vlan1').config.ipv4Address) {
            me.getConfigObject('vlan1').check.isGatewayEqualIp = true
            return false
          }
          return true
        }
      })
      this.$validator.extend('notSameIpGatewayOob', {
        getMessage (field, val) {
          return me.$t('errorMessage.gatewayInvalid')
        },
        validate (value, field) {
          me.getConfigObject('oob').check.isGatewayEqualIp = false
          if (value === me.getConfigObject('oob').config.ipv4Address) {
            me.getConfigObject('oob').check.isGatewayEqualIp = true
            return false
          }
          return true
        }
      })
    },
    isButtonEnable: function () {
      let result = false
      this.ipConfigObjList.forEach(obj => {
        let isModify = this.isModify(obj)
        if (isModify && obj.radioType.selType === 'Static') {
          isModify = !this.checkErrorHas(obj)
        }
        result = result | isModify
      })
      this.$store.commit('updateDataChanged', result)
      return result
    },
    isShowLoadingConfig: function (name, state) {
      let result = false
      if (name !== 'all') {
        this.ipConfigObjList.forEach(obj => {
          if (obj.name === name) {
            obj.check.isShowLoading = state
          }
        })
      } else {
        this.ipConfigObjList.forEach(obj => {
          obj.check.isShowLoading = state
        })
      }
      this.ipConfigObjList.forEach(obj => {
        result = result || obj.check.isShowLoading
      })
      // this.isShowLoading = result
      this.$store.commit('updateFullLoadingStatus', result)
    },
    isOobPortExist: function () {
      return this.sysBoard.OobManagement
    },
    getConfigObject: function (item) {
      let result = this.ipConfigObjList[0]
      this.ipConfigObjList.forEach(obj => {
        if (obj.name === item) {
          result = obj
        }
      })
      return result
    },
    getData: function () {
      this.initConfig()
      this.isShowLoadingConfig('all', true)
      this.ipConfigObjList.forEach(obj => {
        this.getConfigData(obj)
      })
    },
    getConfigData: function (obj) {
      if (obj.type === 'vlan') {
        this.getIP4Configure()
          .then(res => {
            if (res.data && res.data.error_code === 200 && res.data.result) {
              let data = res.data.result
              data.forEach(element => {
                if (element.key === '1') {
                  obj.radioType.selModeEnableType = element.val.enableInterface
                  obj.radioType.originalModeEnableType = element.val.enableInterface
                  obj.check.isModeModify = false
                  obj.radioType.selType = element.val.enableDhcpClient ? 'DHCP' : 'Static'
                  obj.radioType.originalType = element.val.enableDhcpClient ? 'DHCP' : 'Static'
                  obj.config.enableDhcpClient = element.val.enableDhcpClient
                  if (obj.radioType.selType === 'Static') {
                    obj.config.ipv4Address = element.val.ipv4Address
                    obj.config.subnetMask = element.val.subnetMask
                  }
                  obj.originalConfig = JSON.parse(JSON.stringify(obj.config))
                  this.$forceUpdate()
                  this.isShowLoadingConfig(obj.name, false)
                  this.getStatusData(obj)
                }
              })
            }
          })
          .catch(error => {
            this.$log.error(error)
          })
      } else if (obj.type === 'oob') {
        this.getIP4Configure()
          .then(res => {
            if (res.data && res.data.error_code === 200 && res.data.result) {
              let data = res.data.result
              data.forEach(element => {
                if (element.key !== '1') {
                  obj.config.idx = element.key
                  obj.radioType.selModeEnableType = element.val.enableInterface
                  obj.radioType.originalModeEnableType = element.val.enableInterface
                  obj.check.isModeModify = false
                  obj.radioType.selType = element.val.enableDhcpClient ? 'DHCP' : 'Static'
                  obj.radioType.originalType = element.val.enableDhcpClient ? 'DHCP' : 'Static'
                  this.$forceUpdate()
                  if (obj.radioType.selType === 'Static') {
                    obj.config.ipv4Address = element.val.ipv4Address
                    obj.config.nextHop = (element.val.nextHop === 'null') ? '' : element.val.nextHop
                    obj.config.subnetMask = element.val.subnetMask
                    if (element.val.dnsAddress) {
                      obj.config.dns = element.val.dnsAddress[0]
                    } else {
                      obj.config.dns = ''
                    }
                    obj.originalConfig = JSON.parse(JSON.stringify(obj.config))
                    this.$log.debug(obj, obj.originalConfig)
                    this.isShowLoadingConfig(obj.name, false)
                  } else {
                    this.getStatusData(obj)
                  }
                }
              })
            }
          })
          .catch(error => {
            this.$log.error(error)
          })
      }
    },
    onBlur: function (obj) {
      obj.check.isIpInvalid = false
      obj.check.isGetwayInvalid = false
      if (obj.radioType.selType !== 'DHCP') {
        this.$validator.validateAll().then((result) => {
          if (!this.$compareObj(obj.originalConfig, obj.config) && obj.radioType.selType === 'Static') {
            obj.check.isConfigModify = result
          } else {
            obj.check.isConfigModify = false
          }
        }).catch(() => {
          obj.check.isConfigModify = false
        })
      }
    },
    isItemEnableDhcpChecked: function (obj) {
      return obj.radioType.selType === 'DHCP'
    },
    isItemEnableModeChecked: function (obj) {
      if (obj.type !== 'vlan') {
        this.ipConfigObjList.forEach(element => {
          if (element.radioType.selModeEnableType === true && element.type === 'vlan') {
            return false
          }
        })
      }
      return (obj.radioType.selModeEnableType)
    },
    getItemEnableMode: function () {
      let val = this.managementModeOptions[0].value
      for (let i = 0; i < this.ipConfigObjList.length; i++) {
        if (this.ipConfigObjList[i].radioType.selModeEnableType === true) {
          val = this.ipConfigObjList[i].name
          break
        }
      }
      return val
    },
    onSelection: function (obj, item) {
      obj.radioType.selType = item
      obj.config.enableDhcpClient = item === 'DHCP'
      if (obj.config.enableDhcpClient !== obj.originalConfig.enableDhcpClient) {
        obj.check.isConfigModify = true
      } else {
        if (obj.config.enableDhcpClient) {
          obj.check.isConfigModify = false
        }
      }
      setTimeout(() => {
        this.onBlur(obj)
      }, 50)
    },
    onManagementModeTypeChange: function (value) {
      this.ipConfigObjList.forEach(element => {
        element.radioType.selModeEnableType = false
        element.check.isModeModify = false
      })
      let obj = this.getConfigObject(value)
      obj.radioType.selModeEnableType = true
      if (obj.radioType.selModeEnableType !== obj.radioType.originalModeEnableType) {
        obj.check.isModeModify = true
      } else {
        obj.check.isModeModify = false
      }
      obj.config.subnetMask = '255.255.0.0'
      obj.config.nextHop = ''
      setTimeout(() => {
        this.onBlur(obj)
      }, 50)
    },
    isModify: function (obj) {
      let result = false
      if (obj.radioType.selModeEnableType) {
        result = obj.check.isModeModify | obj.check.isConfigModify
      }
      return result
    },
    goSave: function () {
      this.onClose()
      if (this.isButtonEnable()) {
        this.isShowLoadingConfig('all', true)
        if (this.isOobPortExist()) {
          let ipConfig = {
            managementMode: '',
            vlanPort: [],
            oobPort: []
          }
          ipConfig.managementMode = 'oob'
          this.ipConfigObjList.forEach(obj => {
            if (obj.name === 'vlan1' && obj.radioType.selModeEnableType) {
              ipConfig.managementMode = 'vlan1'
            }
          })
          this.ipConfigObjList.forEach(obj => {
            if (this.isModify(obj)) {
              if (obj.type === 'vlan') {
                obj.config.enableDhcpClient = obj.radioType.selType === 'DHCP'
                ipConfig.vlanPort.push(obj.config)
                ipConfig.oobPort.push(obj.config)
              } else if (obj.type === 'oob') {
                obj.config.enableDhcpClient = obj.radioType.selType === 'DHCP'
                ipConfig.oobPort.push(obj.config)
              }
            }
          })
          this.$log.debug(ipConfig)
          this.setIP4MixPort(ipConfig)
            .then(res => {
              if (res.error_code === 200) {
                this.reloadPage()
              }
            })
            .catch(error => {
              this.$log.error(error)
              this.reloadPage()
            })
        } else {
          if (this.ipConfigObjList[0].radioType.selType === 'DHCP') {
            // dhcp
            this.setDHCPIp()
              .then(res => {
                if (res.error_code === 200) {
                  this.reloadPage()
                }
              })
              .catch(error => {
                this.$log.error(error)
                this.reloadPage()
              })
          } else {
            // static
            let config = {
              config: this.ipConfigObjList[0].config,
              dns: this.ipConfigObjList[0].config.dns,
              isDelRoute: (this.ipConfigObjList[0].radioType.originalType === 'DHCP' && !this.ipConfigObjList[0].config.nextHop) ? this.ipConfigObjList[0].status.nextHop : ''
            }
            this.setStatic(config)
              .then(res => {
                if (res.error_code === 200) {
                  this.reloadPage()
                }
              })
              .catch(error => {
                this.$log.error(error)
                this.reloadPage()
              })
          }
        }
      }
    },
    reloadPage: function () {
      let typeList = ['vlan']
      let isDhcp = false
      let ip = ''
      if (this.isOobPortExist()) {
        typeList.push('oob')
      }
      for (let i = 0; i < typeList.length; i++) {
        for (let j = 0; j < this.ipConfigObjList.length; j++) {
          if (this.isModify(this.ipConfigObjList[j]) && this.ipConfigObjList[j].type === typeList[i]) {
            isDhcp = this.ipConfigObjList[j].radioType.selType === 'DHCP'
            ip = this.ipConfigObjList[j].config.ipv4Address
            break
          }
        }
        if (isDhcp || ip !== '') {
          break
        }
      }
      if (isDhcp) {
        setTimeout(() => {
          window.location.reload(true)
        }, this.intervalTime)
      } else {
        if (ip !== '') {
          if (ip === document.location.hostname) {
            setTimeout(() => {
              this.getData()
            }, this.intervalTime)
          } else {
            document.location.href = document.location.protocol + '//' + ip
          }
        } else {
          window.location.reload(true)
        }
      }
    },
    onSaveClick: function () {
      let resultFail = false
      let me = this
      this.ipConfigObjList.forEach(obj => {
        if (this.isModify(obj)) {
          if (this.ipConfigObjList[obj.index].radioType.selType === 'Static') {
            resultFail = resultFail | !this.checkIpAndGetway(this.ipConfigObjList[obj.index])
          }
          if (obj.radioType.originalModeEnableType && obj.radioType.selModeEnableType) {
            me.isOriginalMode = true
          } else {
            me.isOriginalMode = false
          }
        }
      })
      if (!resultFail) {
        this.onOpen()
      }
    },
    checkIpAndGetway: function (obj) {
      let networkID = ''
      let broadcast = ''
      let ip = obj.config.ipv4Address.split('.')
      let mask = obj.config.subnetMask.split('.')
      let getway = (obj.config.nextHop) ? obj.config.nextHop.split('.') : ''
      let wildcard = maskBitwiseNOT()
      function padLeft (str, length) {
        if (str.length >= length) {
          return str
        } else {
          return padLeft('0' + str, length)
        }
      }
      function maskBitwiseNOT () {
        let result = []
        mask.forEach(item => {
          let temp = Number(item).toString(2)
          temp = padLeft(temp, 9 - temp.length)
          temp = temp.split('').map(function (item) {
            if (item === '1') {
              return '0'
            } else {
              return '1'
            }
          }).join('')
          result.push(parseInt(temp, 2).toString())
        })
        return result
      }
      networkID = (ip[0] & mask[0]).toString() + '.' + (ip[1] & mask[1]).toString() + '.' + (ip[2] & mask[2]).toString() + '.' + (ip[3] & mask[3]).toString()
      broadcast = (ip[0] | wildcard[0]).toString() + '.' + (ip[1] | wildcard[1]).toString() + '.' + (ip[2] | wildcard[2]).toString() + '.' + (ip[3] | wildcard[3]).toString()
      if (getway.length > 0) {
        getway = getway.map(item => Number(item))
        if (((ip[0] & mask[0]) <= getway[0] && getway[0] <= (ip[0] | wildcard[0])) && ((ip[1] & mask[1]) <= getway[1] && getway[1] <= (ip[1] | wildcard[1])) && ((ip[2] & mask[2]) <= getway[2] && getway[2] <= (ip[2] | wildcard[2])) && ((ip[3] & mask[3]) <= getway[3] && getway[3] <= (ip[3] | wildcard[3]))) {
          obj.check.isGetwayInvalid = false
        } else {
          obj.check.isGetwayInvalid = true
        }
      }
      if (obj.config.ipv4Address === networkID || obj.config.ipv4Address === broadcast || networkID === '0.0.0.0') {
        obj.check.isSubmaskInvalid = true
      } else {
        obj.check.isSubmaskInvalid = false
      }
      if (obj.check.isGetwayInvalid || obj.check.isIpInvalid || obj.check.isSubmaskInvalid) {
        // obj.check.isConfigModify = false
        return false
      } else {
        return true
      }
    },
    checkErrorHas: function (obj) {
      let result = false
      if (obj.name === 'vlan1') {
        result = this.errors.has('ipSystem') | this.errors.has('subnetSystem') | this.errors.has('gatewaySystem') | this.errors.has('dnsSystem')
      } else if (obj.name === 'oob') {
        result = this.errors.has('ipOob') | this.errors.has('subnetOob') | this.errors.has('gatewayOob') | this.errors.has('dnsOob')
      }
      return result
    },
    getStatusData: function (obj) {
      let me = this
      let meObj = this.ipConfigObjList[obj.index]
      obj.check.isConfigModify = false
      if (obj.type === 'vlan') {
        if (obj.radioType.selType === 'DHCP') {
          this.axios.all([this.getIP4Status(), this.getIP4StatusRoute(), this.getDNSConfig()])
            .then(this.axios.spread(function (status, route, config) {
              // status: get dhcp ip
              if (status.data && status.data.error_code === 200 && status.data.result) {
                let data = status.data
                if (data.result) {
                  data.result.every((element, index, array) => {
                    if (element.key[0] === '1') {
                      let ips = element.key[1].split('/')
                      meObj.status['ipv4Address'] = ips[0]
                      meObj.status['prefixSize'] = ips[1]
                      meObj.status['subnetMask'] = element.key[2]
                    }
                  })
                }
              }
              // route: get dhcp gateway
              if (route.data && route.data.error_code === 200 && route.data.result) {
                let data = route.data.result
                if (data) {
                  data.forEach(element => {
                    if (element.key && element.key.networkAddress === '0.0.0.0') {
                      meObj.status.nextHop = element.key.nextHop
                    }
                  })
                }
              }
              // config: get dns
              if (config.data && config.data.error_code === 200 && config.data.result) {
                let data = config.data.result
                data.some(element => {
                  if (element.val.State === 1) { // 1: DHCP
                    meObj.status.dns = element.val.IpAddress
                    return true
                  }
                  return false
                })
              }
              setTimeout(() => {
                if (me.getItemEnableMode() === 'oob') {
                  meObj.status['ipv4Address'] = ''
                  meObj.status['subnetMask'] = ''
                  meObj.status.dns = ''
                }
              }, 500)
              me.$log.debug('getStatusData', meObj)
              me.isShowLoadingConfig(meObj.name, false)
              me.$forceUpdate()
            }))
        } else {
          this.axios.all([this.getIP4ConfigRoute(), this.getDNSConfig(), this.getIP4StatusRoute()])
            .then(this.axios.spread(function (route, config, statusRoute) {
              // route: get staticIp gateway
              if (route.data && route.data.error_code === 200 && route.data.result) {
                let data = route.data.result
                data.forEach(element => {
                  if (element.val.vlanID === '1') {
                    meObj.config.nextHop = element.key.nextHop
                  }
                })
              }
              // config: get dns
              if (config.data && config.data.error_code === 200 && config.data.result) {
                let data = config.data.result
                data.some(element => {
                  if (element.val.State === 0) { // 0: static
                    meObj.config.dns = element.val.IpAddress
                    meObj.config.dnsIndex = element.key
                    return true
                  }
                  return false
                })
              }
              meObj.originalConfig = JSON.parse(JSON.stringify(meObj.config))
              me.$log.debug(meObj, meObj.originalConfig)
              me.isShowLoadingConfig(meObj.name, false)
              me.$forceUpdate()
            }))
        }
      } else if (obj.type === 'oob') {
        if (obj.radioType.selType === 'DHCP') {
          this.getIP4Status()
            .then(res => {
              if (res.data && res.data.error_code === 200 && res.data.result) {
                let data = res.data.result
                data.forEach(element => {
                  if (element.key !== '1') {
                    meObj.radioType.selType = element.val.enableDhcpClient ? 'DHCP' : 'Static'
                    meObj.radioType.originalType = element.val.enableDhcpClient ? 'DHCP' : 'Static'
                    meObj.status.ipv4Address = (element.val.ipv4Address === 'null') ? '' : element.val.ipv4Address
                    meObj.status.nextHop = (element.val.nextHop === 'null') ? '' : element.val.nextHop
                    meObj.status.subnetMask = (element.val.subnetMask === '0.0.0.0') ? '' : element.val.subnetMask
                    meObj.status.dns = ''
                    if (element.val.dnsAddress !== null) {
                      if (element.val.dnsAddress.length > 0) {
                        meObj.status.dns = element.val.dnsAddress[0]
                      }
                    }
                  }
                })
              }
              me.isShowLoadingConfig(meObj.name, false)
              me.$forceUpdate()
            })
            .catch(error => {
              this.$log.error(error)
            })
        }
      }
      this.$forceUpdate()
    },
    getErrorMsg: function (obj, data, field) {
      let result = ''
      if (data) {
        if (data.indexOf('required') > -1) {
          result = this.$t('errorMessage.ipAndSubnetEmpty')
        } else {
          if (field === 'subnet') {
            result = this.$t('errorMessage.subnetFormat')
          } else if (field === 'gateway' && obj.check.isGatewayEqualIp) {
            result = this.$t('errorMessage.gatewayInvalid')
          } else {
            result = this.$t('errorMessage.ipInvalid')
          }
        }
      } else {
        if (field === 'gateway' && obj.check.isGetwayInvalid) {
          result = this.$t('errorMessage.ipInvalid')
        } else if (field === 'ip' && obj.check.isIpInvalid) {
          result = this.$t('errorMessage.ipInvalid')
        } else if (field === 'ip' && obj.check.isSubmaskInvalid) {
          result = this.$t('errorMessage.submaskInvalid')
        }
      }
      return result
    },
    onMenuChange: function (obj, value) {
      obj.config.subnetMask = value
      this.onBlur(obj)
    },
    onOpen () {
      this.openModal(this.modalname)
      this.$modal.show(this.modalname)
    },
    onClose () {
      this.closeModal(this.modalname)
      this.$modal.hide(this.modalname)
    },
    ...mapMutations([ 'openModal', 'closeModal' ]),
    ...mapActions([
      'getIP4Configure', 'getIP4Status', 'getDNSConfig', 'setDHCPIp', 'getIP4ConfigRoute', 'getIP4StatusRoute', 'getDNSConfig', 'setDNS', 'addDNS', 'delDNS', 'delRoute', 'setStatic', 'setIP4MixPort'
    ])
  },
  computed: {
    ...mapGetters(['getTopModalName']),
    ...mapState({
      sysBoard: state => state.module.sysBoard,
      isDataChanged: state => state.app.isDataChanged,
      currentUser: state => state.module.currentUser,
      intervalTime: state => state.app.intervalTime,
      showFullLoading: state => state.module.showFullLoading
    }),
    ifTop () {
      this.$log.debug('this.getTopModalName :' + this.getTopModalName)

      if (this.getTopModalName !== this.modalname) {
        return 'noTopModal'
      } else {
        return 'none'
      }
    },
    modalTitle () {
      let ip = this.getConfigObject('vlan1')
      let result = ''
      for (let i = 0; i < this.ipConfigObjList.length; i++) {
        if (this.isModify(this.ipConfigObjList[i])) {
          ip = this.ipConfigObjList[i].config.ipv4Address
          if (this.ipConfigObjList[i].radioType.selType === 'DHCP') {
            result = this.$t('systemDhcp.dhcpalert')
          } else {
            result = this.$t('systemDhcp.staticalert', {0: ip})
          }
          break
        }
      }
      if (this.isOriginalMode) {
        return result
      } else {
        return this.$t('warning')
      }
    },
    modalContent () {
      let result = this.$t('systemDhcp.qfinderContent')
      if (this.isOriginalMode) {
        return result
      } else {
        return this.$t('systemDhcp.managementModalContent')
      }
    }
  }
}
</script>
<style lang="scss" scoped>

.sysdhcp {
  position: relative;
  border-bottom-left-radius: 4px;
  border-bottom-right-radius: 4px;
  >.content-body {
    padding: 20px 10px 10px 10px;
    div.content-body-header{
      padding-left: 20px !important;
    }
    .formDeviceMode {
      width: auto;
      height: auto;
      .formselect {
        height: 30px;
        margin-bottom: 10px;
        .title {
          margin-right: 12px;
        }
      }
      .formlabel {
        height: 15px;
      }
    }
    .formDevice {
      display: inline-block;
      width: 420px;
      vertical-align: top;
      &.disabled{
        .title, .q-radio, /deep/ .q-radio > .text, .forminput .table-row .title, .forminput .table-row span {
          color: #AEAEAE;
          cursor: default;
          pointer-events: none;
        }
      }
    }
    .formRow {
      &.static {
        margin-top: 32px;
      }
      &.deviceMachine {
        padding: 0px;
        margin-bottom: 30px;
        /deep/ svg {
          height: auto;
          &.back {
            padding-top: 20px;
          }
        }
      }
      &.deviceName {
        margin-bottom: 20px;
      }
      .formlabel {
        /deep/ .q-radio {
          > .text {
            font-size: 14px;
            font-family: 'Roboto-M', 'Microsoft JhengHei' !important;
          }
        }
        .info {
          font-size: 14px;
          color: #195A87;
          line-height: 14px;
          font-weight: 400;
          font-family: 'Roboto-R', 'Microsoft JhengHei' !important;
        }
      }
      &.deviceName {
        .title {
            font-size: 16px;
            color: #2f2f2f;
            line-height: 16px;
            font-weight: 600;
            font-family: 'PingFang TC', 'Microsoft JhengHei' !important;
        }
      }
      .formselect {
        display: inline-block;
        vertical-align: middle;
        .title {
          font-size: 14px;
          color: #000000;
          line-height: 14px;
          font-weight: 400;
          width: auto;
          display: inline-block;
          font-family: 'Roboto-R', 'Microsoft JhengHei' !important;
        }
      }
      .forminput {
        margin: 10px 0px 0px 30px;
        >.table-row {
          margin-bottom: 10px;
          .title {
            font-size: 14px;
            color: #000000;
            line-height: 14px;
            font-weight: 500;
            width: auto;
            display: inline-block;
            font-family: 'Roboto-R', 'Microsoft JhengHei' !important;
          }
          span {
            font-size: 14px;
            color: #000000;
            line-height: 14px;
            display: inline-block;
            font-family: 'Roboto-R', 'Microsoft JhengHei' !important;
          }
          input {
            border: 1px solid #979797;
            border-radius: 4px;
            font-size: 14px;
            height: 30px;
            color: #000000;
            line-height: 30px;
            width: 150px;
            font-family: 'Roboto-R', 'Microsoft JhengHei' !important;
          }
          >.item {
            display: inline-block;
            vertical-align: top;
            width: 150px;
          }
        }
      }
      .refresh {
        cursor: pointer;
        display: inline-block;
        vertical-align: middle;
        margin: 0 0 0 5px;
        font-size: 16px;
        color: #000;
        &:hover {
          color: #89A5F4;
        }
        &:active {
          color: #2847A0;
        }
      }
    }
    .content-body-footer {
      top: calc(100% - 50px) !important;
      .q-button {
        min-width: 80px;
        font-family: 'Roboto-M', 'Microsoft JhengHei' !important;
      }
    }
    .scrollbar-body {
      height: calc(100% - 40px);
      padding: 0px 10px;
    }
    .line {
      width: 1px;
      height: 530px;
      border-right: solid 1px #d8d8d8;
      margin: 12px 5px;
      display: inline-block;
      vertical-align: top;
    }
  }
  .alert .q-v--modal {
    height: auto;
    .modal-footer {
      justify-content: flex-end;
    }
  }
  /deep/ .q-select {
    width: auto;
    height: 30px;
    vertical-align: top;
    border: 1px solid #848484;
    .dropdown-menu {
      .scrollbar-body {
        .scroll-content > li {
          > a {
            font-size: 14px !important;
            font-family: 'Roboto-R', 'Microsoft JhengHei' !important;
            color: #4C4C4C;
          }
        }
      }
    }
    .display-label {
      font-size: 14px !important;
      line-height: 28px !important;
      text-overflow: ellipsis;
      white-space: nowrap;
      overflow: hidden;
      font-family: 'Roboto-R', 'Microsoft JhengHei' !important;
      color: #4C4C4C;
    }
    .triangle {
      color: #4C4C4C;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/SystemDhcp.vue